var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),(_vm.isMaintenanceMode)?_c('maintenance-notification'):_vm._e(),(_vm.$auth.loading)?_c('div',{staticClass:"app-auth-loading"},[_c('Spinner')],1):_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"page-content"})],1),_c('Footer'),_c('DastPromoBlock'),_c('AppToast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }